import { useMemo } from 'react'

import { User as UserType } from 'types/global'
import { LANGUAGE } from 'utils/constants/locale'
import { useAppDispatch, useAppSelector, User } from 'store'
import { QUOTATION_APPROVAL_LEVEL_FALLBACK, USER_PROFILES } from 'utils/constants'

const useUser = () => {
  const dispatch = useAppDispatch()
  const { selectedBranch, user, userBranches } = useAppSelector((state) => state.user)

  const data: UserType = useMemo(
    () => ({
      ...user,
      email: user?.email ?? '',
      firstName: user?.firstName ?? '',
      id: user?.id ?? '',
      isActive: user?.isActive ?? 0,
      isSuperAdmin: user?.userProfileName === USER_PROFILES.SuperAdmin,
      isApproved: user?.isApproved ?? 0,
      isDeleted: user?.isDeleted ?? 0,
      isVerified: user?.isVerified ?? 0,
      lastName: user?.lastName ?? '',
      mobile: user?.mobile ?? '',
      teams: user?.teams ?? [],
      userPermissions: user?.userPermissions ?? [],
      userProfileId: user?.userProfileId ?? '',
      userProfileName: user?.userProfileName ?? '',
      hasAcceptedPDPA: user?.hasAcceptedPDPA ?? false,
      pdpa: user?.pdpa ?? {
        id: 0,
        text:
          'Starting this meeting will capture your location and log your current date and time. Clicking on proceed means that you agree with sharing your location.',
      },
      quotationApprovalLevel: user?.quotationApprovalLevel || [],
      twoFactors: user?.twoFactors ?? null,
      userPreferences: {
        language: user?.userPreferences?.language ?? LANGUAGE.en,
        updatedTs: user?.userPreferences?.updatedTs ?? null,
        leadDetailsVersionPreference: user?.userPreferences?.leadDetailsVersionPreference ?? 'v1',
      },
      supervisor: {
        id: user?.supervisor?.id || null,
        name: user?.supervisor?.name || null,
        email: user?.supervisor?.email || null,
      },
      master: user?.master || null,
    }),
    [user],
  )

  const updateCurrentUser = (value: UserType) => {
    dispatch(User.updateUser(value))
  }

  return {
    currentBranch: selectedBranch,
    currentQuotationApprovalLevel:
      data.quotationApprovalLevel.find((i) => i.branchId === selectedBranch?.id)?.approvalLevel ||
      QUOTATION_APPROVAL_LEVEL_FALLBACK,
    currentUser: data,
    updateCurrentUser,
    userBranches,
  }
}

export default useUser
